import config from 'config/config'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { deleteMedium } from 'redux/media'
import { Card, Icon, Image, Table } from 'semantic-ui-react'
import EditDropdown from './EditDropdown'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      deleteMedium,
    },
    dispatch
  )
}

class MediaList extends React.Component {
  state = {}

  render() {
    // TODO: add highlighting
    const { viewAsList, filteredMedia, itemsPerRow } = this.props //ownProps
    const { addMedium, deleteMedium, customActions } = this.props
    /**
     * @return {XML|boolean}
     */
    const Thumbnail = ({ medium, customProps, src }) => {
      if (medium && medium.content_type.match(/^image/))
        return <Image {...customProps} className="indicate-link" src={src} />
      return (
        medium &&
        medium.content_type === 'application/pdf' && (
          <Icon name="file pdf outline" size="large" />
        )
      )
    }

    const listItems = () =>
      filteredMedia.map((medium) => (
        <Table.Row
          key={medium.id}
          onClick={(event) => {
            event.preventDefault()
            if (medium && medium.content_type.match(/^image/)) {
              addMedium(medium)
            }
          }}>
          <Table.Cell width={1}>
            <Thumbnail
              src={config.api_url + medium.thumb_url}
              medium={medium}
              customProps={{ size: 'mini' }}
            />
          </Table.Cell>
          <Table.Cell verticalAlign="middle" width={9}>
            <span className="german tag ellipsis">
              {medium && medium.title_de}
            </span>
            <span className="french tag ellipsis">
              {medium && medium.title_fr}
            </span>
            <span className="filename ellipsis">
              {medium && medium.file_name}
            </span>
          </Table.Cell>
          <Table.Cell className="unobtrusive" verticalAlign="middle" width={1}>
            {medium.file_size}
          </Table.Cell>
          <Table.Cell textAlign="right" width={1}>
            <EditDropdown
              medium={medium}
              deleteMedium={deleteMedium}
              customActions={customActions}
            />
          </Table.Cell>
        </Table.Row>
      ))

    const gridItems = () =>
      filteredMedia.map((medium) => (
        <Card
          key={medium.id}
          onClick={(event) => {
            event.preventDefault()
            if (medium && medium.content_type.match(/^image/)) {
              addMedium(medium)
            }
          }}>
          <Thumbnail
            src={config.api_url + medium.thumb_large_url}
            medium={medium}
            customProps={{ fluid: true }}
          />
          <Card.Content>
            <EditDropdown
              medium={medium}
              deleteMedium={deleteMedium}
              customActions={customActions}
            />
          </Card.Content>
          {medium &&
            medium.content_type === 'application/pdf' && (
              <Card.Description>
                <span className="german tag ellipsis">{medium.title_de}</span>
                <span className="french tag ellipsis">{medium.title_fr}</span>
              </Card.Description>
            )}
        </Card>
      ))

    const MediaTable = () => (
      <Table
        basic="very"
        size="small"
        compact
        selectable
        singleLine
        className="spaced"
        fixed>
        <Table.Body children={listItems()} />
      </Table>
    )

    return viewAsList ? (
      <MediaTable />
    ) : (
      <Card.Group itemsPerRow={itemsPerRow} children={gridItems()} />
    )
  }
}

MediaList = connect(mapStateToProps, mapDispatchToProps)(MediaList)
export default MediaList



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/MediaList.jsx